<template>
  <div class="playbox-container">
    <div class="all-bet">
      <Canvas :anim="table" :game-state="gameState" :dealer-height="220"/>
      <div class="bg-qs">
        <ButtonsComponent
          :name="name"
          :table="table"
          :round="round"
          :score="flipScore"
          :data="data"
          :odds="odds"
          :game-state="gameState"
          :is-highlight-result="isHighlightResult"
          :current-chip="currentChip"
          :window-focus="windowFocus"
        />
      </div>
      <!-- <FlipResult v-if="gameState === 'RESULTING'"
        :table="table"
        :score="flipScore"
      /> -->
      <BetDialog
        :data="data"
        @handleSelectChip="handleSelectChip"
        @handleClearBetQueueValue="handleClearBetQueueValue"
        @handleBetting="handleBetting"
        @handleReBetting="handleReBetting"
      />
    </div>
    <div v-if="gameState === 'LOCKING' ||
        gameState === 'RESULTING' ||
        gameState === 'LOADING' ||
        gameState === 'WAITING_RESULT' ||
        gameState === 'WAITING_NEW_GAME'"
      class="overlay-Block "
      :class="classObject"
    />
    
    <!-- <RebetContainer
      :is-rebet="isRebet"
      @handle-reBetting="handleReBetting"
    /> -->
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import RebetContainer from '@components/common/rebet-container.vue';
import FlipResult from '@components/xocdia/flip-result.vue';
import ButtonsComponent from '@components/xocdia/buttons.vue';
import BetDialog from '@/src/components/common/bet-dialog.vue';
import Canvas from "@components/common/canvas.vue";
import { GAMESTATE } from '@config/constants.js';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    RebetContainer,
    // eslint-disable-next-line vue/no-unused-components
    FlipResult,
    // eslint-disable-next-line vue/no-unused-components
    ButtonsComponent,
    BetDialog,
    // eslint-disable-next-line vue/no-unused-components
    Canvas,
  },
  props: {
    name: { type: String, default: "" },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
    isHighlightResult: Boolean,
    table: { type: String, default: "" },
    round: { type: Number, default: 0 },
    flipScore: { type: Object, default: () => ({})},
    score: { type: Object, default: () => ({})},
    data: { type: Object, default: () => ({})},
    odds: { type: Object, default: () => ({})},
    windowFocus: { type: Number, default: 0 },
  },
  data() {
    return {
      currentChip: 10,
    }
  },
  computed: {
    ...mapState('user', ['token', 'agentId', 'limit']),
    ...mapState('xocdia', ['xocdia78']),
    isRebet: function(){
      if(this.data.previousBetting.length > 0 &&
        this.gameState === GAMESTATE.BETTING) {
        // console.log('isRebet', this.data);
        return true;
      }
      return false;
    },
    classObject: function(){
      return { "overlay-Block-Opacity": this.isHighlightResult }
    },
    max: function() {
      let maxBet = 0;
      for (const [, value] of Object.entries(this.xocdia78.bettingQueueValue)) {
        maxBet += value;
      }
      let max = this.limit - maxBet;
      if(max > this.data.max) max = this.data.max;
      if(max < this.data.min) max = -1; // money is not enough
      return max;
    },
  },
  watch: {
    gameState: function(newVal){
      if(newVal === "LOCKING"){
        this.clearBetQueuePreviousBetting(this.table);
      }
    },
    // windowFocus: function(newVal, oldVal){
    //   console.log('[xocdia][body][watch] windowFocus', newVal);
    // }
  },
  methods: {
    ...mapActions('xocdia', ['callBetting', 'callReBetting', 'clearBetQueuePreviousBetting']),
    handleReBetting(event, value) {
      const data = this.data.previousBetting.map(val => ({ ...val, ...{ roundId: this.round , token: this.token, agentId : this.agentId } }));
      let total = 0;
      for (let i = 0; i < this.data.previousBetting.length; i++) {
        total += this.data.previousBetting[i].amount;
      }
      console.log('handleReBetting - total', total, this.max);
      if(total > this.max){
        this.$bvModal.show('modal-unbalance');
      }
      else {
        const bet = { table: this.table, value: data };
        this.callBetting(bet);
      }
    },
    handleSelectChip(event) {
      const { chip } = event;
      this.currentChip = chip;
      // console.log('handleSelectChip', chip);
      
    },
    handleClearBetQueueValue(event) {
      const bettingQueueValueCount = Object.entries(this.data.bettingQueueValue).length;
      // console.log('show dialog', bettingQueueValueCount);
      if(this.token === "" || this.token === undefined){
        this.$bvModal.show('modal-unauthorization');
      }
      else if(bettingQueueValueCount === 0){
        this.$bvModal.show('modal-emptybettingqueue');
      } else {
        this.clearBetQueuePreviousBetting(this.table);
      }
    },
    handleBetting(event) {
      // console.log('bettingQueueValue', this.data.bettingQueueValue);
      const bettingQueueValueCount = Object.entries(this.data.bettingQueueValue).length;
      if(this.token === "" || this.token === undefined){
        this.$bvModal.show('modal-unauthorization');
      }
      else if(bettingQueueValueCount === 0){
        this.$bvModal.show('modal-emptybettingqueue');
      } else {
        const bets = [];
        for (const [key, value] of Object.entries(this.data.bettingQueueValue)) {
          const betType = key.substring("xocdia78".length + 1);
          const betValue = {
            roundId: this.round,
            betType,
            bettingId: key,
            amount: value,
            token: this.token,
            table: this.table,
          };
          // console.log('betValue', betValue);
          bets.push(betValue);
        }
        this.callBetting({ table: this.table, value: bets });
      }
    }
  },
}
</script>

<style>

</style>
